export var StoreSpecificTypeEnum;
(function (StoreSpecificTypeEnum) {
    StoreSpecificTypeEnum["REGULAR"] = "regular";
    StoreSpecificTypeEnum["CATERING"] = "catering";
    StoreSpecificTypeEnum["HOLIDAYS"] = "holidays";
    StoreSpecificTypeEnum["SPECIAL"] = "special";
    StoreSpecificTypeEnum["GROCERY"] = "grocery";
    StoreSpecificTypeEnum["FRANCHISE_CENTRAL"] = "franchise_central";
    StoreSpecificTypeEnum["OTHER"] = "other";
})(StoreSpecificTypeEnum || (StoreSpecificTypeEnum = {}));
//# sourceMappingURL=StoreSpecificTypeEnum.js.map